export function installGlobalTableBlur() {
    if (window.__mbbGlobalTableBlurInstalled) return;
    window.__mbbGlobalTableBlurInstalled = true;

    function isTableRelated(el) {
      if (!el) return false;

      // NOTE: minibar is intentionally NOT included here,
      // so clicking the toolbar will blur the table.
      return !!el.closest?.(
        [
          // any table area
          ".table-scroll",
          "table",

          // table engine overlays/menus (keep focus)
          ".te-popover",
          ".te-context-menu",
          ".te-menu",
          ".te-dropdown",
        ].join(",")
      );
    }

    function blurActiveElementIfInTable() {
      const ae = document.activeElement;
      if (!ae) return;

      const isEditable =
        ae.matches?.("input, textarea, select, button, [contenteditable='true']") ||
        ae.getAttribute?.("contenteditable") === "true";

      if (!isEditable) return;

      // Only blur if the focused element lives inside a table-ish region
      if (ae.closest?.(".table-scroll") || ae.closest?.("table")) {
        try { ae.blur(); } catch {}
        try { window.getSelection?.().removeAllRanges?.(); } catch {}
      }
    }

    // Capture-phase so we run even if table handlers stopPropagation
    document.addEventListener(
      "pointerdown",
      (e) => {
        if (isTableRelated(e.target)) return;
        blurActiveElementIfInTable();
      },
      true
    );

    document.addEventListener(
      "keydown",
      (e) => {
        if (e.key !== "Escape") return;
        blurActiveElementIfInTable();
      },
      true
    );
  }